import { Redirect, Route, Switch } from 'react-router-dom';
import TimesheetsPage from './TimesheetsPage.tsx';
import IntegrationsPage from './IntegrationsPage.tsx';
import NetsuiteIntegrationPage from './NetsuiteIntegrationPage.tsx';
import NetsuiteIntegrationSuiteql from './NetsuiteIntegrationSuiteql.tsx';
import NetsuiteProjectSyncUtilities from './NetsuiteProjectSyncUtilities.tsx';
import TasksPage from './TasksPage.tsx';
import Page from '../../common/components/Page';
import SettingsContainer from './SettingsContainer';
import ConfigurationCollection from './ConfigurationCollection.js';
import AdminDashboardPage from '../../admin/components/AdminDashboardPage';
import JobQueuePage from './JobQueuePage';

const SuperAdminPage = () => (
  <Page full>
    <Switch>
      <Route exact path="/super-admin" render={() => <Redirect to="/super-admin/data-checks" />} />
      <Route exact path="/super-admin/data-checks" render={() => <AdminDashboardPage />} />
      <Route exact path="/super-admin/queue" render={() => <JobQueuePage />} />
      <Route exact path="/super-admin/configurations" render={() => <ConfigurationCollection />} />
      <Route exact path="/super-admin/timesheets" render={() => <TimesheetsPage />} />
      <Route exact path="/super-admin/integrations" render={() => <IntegrationsPage />} />
      <Route exact path="/super-admin/integrations/netsuite/syncs" render={() => <NetsuiteIntegrationPage />} />
      <Route exact path="/super-admin/integrations/netsuite/suiteql" render={() => <NetsuiteIntegrationSuiteql />} />
      <Route exact path="/super-admin/integrations/netsuite/project-sync-utilities" render={() => <NetsuiteProjectSyncUtilities />} />
      <Route exact path="/super-admin/settings" render={() => <SettingsContainer />} />
      <Route exact path="/super-admin/tasks" render={() => <TasksPage />} />
    </Switch>
  </Page>
);

export default SuperAdminPage;
